import React, { useState } from "react";

/**
 * @param {{label?:string,inputProps:React.InputHTMLAttributes<HTMLInputElement>,icon:"email-icon" |"user-icon" |"search-icon" |"lock-icon" |"eye-icon" ,secondIcon,fullWidth:boolean}}
 * @returns {JSX.Element}
 */
const InputWithIcon = ({ label, inputProps, icon, secondIcon, fullWidth }) => {
    const [viewText, setViewText] = useState();
    const [addicionalStyle, setAddicionalStyle] = useState();

    const handleViewPass = () => {
        setAddicionalStyle("view");
        setTimeout(() => setAddicionalStyle(undefined), [150]);
        setTimeout(() => setViewText(prev => !prev), [200]);
    };

    return (
        <div className={`input-whit-icon-container ${fullWidth ? "fullwidth" : ""}`}>
            {label && <label htmlFor={label}>{label}</label>}
            <div className={`input-with-icon`}>
                {icon && <i className={icon} />}
                <input
                    className={`${icon ? "icon" : ""} ${addicionalStyle ?? ""}`}
                    {...inputProps}
                    {...(secondIcon && viewText ? { type: "text" } : "")}
                    {...(label ? { id: label } : "")}
                />
                {secondIcon && (
                    <i className={secondIcon} onClick={handleViewPass} />
                )}
            </div></div>
    );
};

export default InputWithIcon;
